<template>
  <div class="main">
    <my_menu2 page_name="财务项目组" back_type="close" back_icon="md-close"></my_menu2>
    <div style="height:45px"></div>

    <div class="content">
      <Tabs v-model="tabs_index">
        <TabPane label="财务项目组列表" name="0">
          <div>
            <div class="search_box">
              <Cascader size="small" style="font-size: 10px; margin-right: 10px" :data="dep_options" placeholder="筛选部门"
                v-model="select_dep" v-width="200" @on-change="cascader_change" />

              <Select @on-change="operation_status_change" size="small" v-model="operation_status_index"
                style="width: 100px; margin-right: 10px">
                <Option v-for="item in operation_status_list" :value="item.value" :key="item.value">{{ item.label }}
                </Option>
              </Select>

              <Input @on-search="search" v-model="search_key" style="width: 200px" size="small" search enter-button
                placeholder="按名称搜索" />
            </div>

            <div class="table_box">
              <Table size="small" :height="windowHeight - 175" :columns="group_columns" :data="group_list">
                <template #operation_status="{ row }">
                  <span class="project_tag" v-if="row.operation_status == 0">正常</span>

                  <span class="project_tag2" v-else>停止</span>
                </template>
                <template #project_count="{ row }">
                  <span :class="row.project_count > 0 ? 'project_count_tag' : 'project_count_tag2'"
                    @click="click_project_count(row)">{{
                      row.project_count
                    }}</span>
                </template>


                <template #name="{ row }">
                  <span>{{ row.name }}</span>

                  <Icon @click="update_group(row)" class="editor_icon" color="#333" size="14"
                    type="ios-create-outline" />
                </template>
                <template #contract_url="{ row }">
                  <a target="_blank" class="down_pdf_a" @click="down_pdf(row.contract_url)">下载</a>
                </template>
                <template #del="{ row }">
                  <a target="_blank" class="down_pdf_a" @click="del_project_group(row.project_group_id)">删除</a>
                </template>
              </Table>
            </div>
            <div class="page_div">
              <Page @on-change="page_change" :total="total_count" :page-size="limit" show-total v-model="page" />
            </div>
          </div>
        </TabPane>
        <TabPane label="新建财务项目组" name="1">
          <div class="content_inner">
            <div class="field_item">
              <div class="field_title">财务项目组全称：</div>
              <Input v-model="company_name" placeholder="请输入xxx公司" style="width: 420px" />
            </div>

            <div class="field_item">
              <div class="field_title">项目工作区域：</div>
              <Cascader filterable :data="city_options" placeholder="请选择所属地区" v-model="select_city" v-width="420" />
            </div>
            <div class="field_item">
              <div class="field_title">公司主营：</div>
              <Input v-model="business" placeholder="请简要描述公司主营15字以内" style="width: 420px" />
            </div>
          </div>
          <div class="box_line"></div>
          <div class="content_inner">
            <div class="field_item">
              <div class="field_title">业务合同PDF：</div>
              <Upload :action="upload_url" :on-success="contract_upload_success" accept=".pdf">
                <Button style="font-size: 12px; width: 200px" icon="ios-cloud-upload-outline">上传业务合同PDF</Button>
              </Upload>
            </div>
            <div class="field_item">
              <div class="field_title">合同起止时间：</div>
              <DatePicker @on-change="contract_start_chnage" type="date" placeholder="合同开始时间"
                style="width: 200px; margin-right: 20px" />
              <DatePicker @on-change="contract_end_chnage" type="date" placeholder="合同到期时间" style="width: 200px" />
            </div>
          </div>
          <div class="box_line"></div>
          <div class="content_inner">
            <div class="field_item">
              <div class="field_title">所属财务区划：</div>
              <Cascader filterable :data="dep_options" v-model="select_dep" v-width="200" />
            </div>
            <div class="field_item">
              <div class="field_title">金蝶客户编码：</div>
              <Input maxlength="10" v-model="jindie_code" placeholder="金蝶系统客户编码"
                style="width: 200px" />
            </div>
            <div class="field_item">
              <div class="field_title">金蝶部门编码：</div>
              <Input maxlength="10" v-model="jindie_salesdept" placeholder="金蝶系统部门编码"
                style="width: 200px" />
            </div>
          </div>


          <div class="add_button_div">
            <Button @click="add_project" type="primary" style="font-size: 12px" icon="md-add">确认新增项目</Button>
          </div>
        </TabPane>

        <TabPane label="更新财务项目组" name="2" disabled>
          <div class="content_inner">
            <div class="field_item">
              <div class="field_title">财务项目组全称：</div>
              <Input v-model="update_group_item.name" placeholder="请输入xxx公司" style="width: 420px" />
            </div>
            <div class="field_item">
              <div class="field_title">项目工作区域：</div>
              <Cascader filterable :data="city_options" placeholder="请选择所属地区" v-model="update_group_item.address_code"
                v-width="420" />
            </div>
            <!-- <div class="field_item">
              <div class="field_title">公司主营：</div>
              <Input
                maxlength="30"
                v-model="update_group_item.business"
                placeholder="请简要描述公司主营,30字以内"
                style="width: 420px"
              />
            </div> -->
            <div class="field_item">
              <div class="field_title">运营状态：</div>
              <Select v-model="update_group_item.operation_status" style="width: 200px">
                <Option v-for="item in operation_status_list_2" :value="item.value" :key="item.value">{{ item.label }}
                </Option>
              </Select>
            </div>
          </div>
          <div class="box_line"></div>

          <div class="content_inner">
            <div class="field_item">
              <div class="field_title">所属财务区划：</div>
              <Cascader filterable :data="dep_options" v-model="update_group_item.dep_id" v-width="450" />
            </div>
            <div class="field_item">
              <div class="field_title">金蝶客户编码：</div>
              <Input maxlength="10" v-model="update_group_item.jindie_code" placeholder="金蝶系统客户编码"
                style="width: 200px" />
            </div>
            <div class="field_item">
              <div class="field_title">金蝶部门编码：</div>
              <Input maxlength="10" v-model="update_group_item.jindie_salesdept" placeholder="金蝶系统部门编码"
                style="width: 200px" />
            </div>
            <!-- <div class="field_item">
              <div class="field_title">财务编码：</div>
              <Input
                maxlength="10"
                v-model="update_group_item.caiwu_code"
                placeholder="财务项目组子编码"
                style="width: 200px"
              />
            </div>
            <div class="field_item">
              <div class="field_title">财务编码确认：</div>
              <Input
                maxlength="10"
                v-model="update_group_item.caiwu_code_status"
                placeholder="0待确认1已确认"
                style="width: 200px"
              />
            </div> -->
          </div>

          <div class="add_button_div">
            <Button @click="update_project" type="primary" style="font-size: 12px" icon="md-add">确认更新</Button>
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import my_menu2 from "@/component/menu/menu2.vue";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      upload_url:
        process.env.VUE_APP_HOST +
        "/project_manage/create/upload_contract?token=" +
        this.$cookies.get("dx_token"),
      city_options: [],
      dep_options: [],
      select_city: [],
      company_name: "",
      company_short_name: "",
      contract_start_time: "",
      contract_end_time: "",
      select_dep: [],
      business: "",
      contract_url: "",
      tabs_index: 0,
      jindie_salesdept:'',
      jindie_code:"",


      group_columns: [],
      group_list: [],
      total_count: 0,
      limit: 20,
      page: 1,
      search_key: "",

      update_group_item: {
        project_group_id: "",
        name: "",
        caiwu_code: 0,
        address_code: [],
        business: "",
        dep_id: [],
        operation_status: 0,
        jindie_code: "",
        jindie_salesdept: ""
      },
      operation_status_index: -1,
      operation_status_list: [
        { label: "所有项目", value: -1 },
        { label: "正常项目", value: 0 },
        { label: "停止项目", value: 1 },
      ],
      operation_status_list_2: [
        { label: "正常项目", value: 0 },
        { label: "停止项目", value: 1 },
      ],
    };
  },

  mounted() {
    this.window_change();
    this.get_city_options();
    this.get_dep_options();
    this.get_group_project();
  },

  methods: {
    del_project_group_request(project_group_id) {
      var that = this;
      var obj = {
        project_group_id: project_group_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/project_group_del",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_group_project();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //删除项目组
    del_project_group(project_group_id) {
      console.log(project_group_id);
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>真的要删除这个项目组吗？删除后项目组下的项目也会一并删除</p>",
        onOk: () => {
          that.del_project_group_request(project_group_id);
        },
        onCancel: () => { },
      });
    },

    operation_status_change(e) {
      console.log(e);
      this.page = 1;
      this.get_group_project();
    },
    //确认更新
    update_project() {
      if (this.update_group_item.name == "") {
        this.$Message.error("请输入项目名称");
        return;
      }

      if (this.update_group_item.address_code.length == 0) {
        this.$Message.error("请选择项目区域");
        return;
      }
      // if (this.update_group_item.business == "") {
      //   this.$Message.error("请选择公司主营");
      //   return;
      // }
      if (this.update_group_item.dep_id == "") {
        this.$Message.error("请选择所属部门");
        return;
      }
      if (this.update_group_item.caiwu_code == "") {
        this.$Message.error("请输入编码");
        return;
      }

      var that = this;
      var obj = {
        project_group_id: this.update_group_item.project_group_id,
        operation_status: this.operation_status_index,
        name: this.update_group_item.name,
        address_code: this.update_group_item.address_code,
        business: this.update_group_item.business,
        dep_id: this.update_group_item.dep_id,
        operation_status: this.update_group_item.operation_status,
        caiwu_code: this.update_group_item.caiwu_code,
        caiwu_code_status: this.update_group_item.caiwu_code_status,
        jindie_code: this.update_group_item.jindie_code,
        jindie_salesdept: this.update_group_item.jindie_salesdept
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/update_project_group",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_group_project();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    cascader_change(e) {
      console.log(e);
      this.page = 1;
      this.select_dep = e;
      this.get_group_project();
    },



    update_group(item) {
      console.log(item);
      this.tabs_index = "2";
      this.update_group_item.project_group_id = item.project_group_id;
      this.update_group_item.name = item.name;
      this.update_group_item.address_code = item.address_code;
      this.update_group_item.business = item.business;
      this.update_group_item.dep_id = item.dep_id;
      this.update_group_item.operation_status = item.operation_status;
      this.update_group_item.caiwu_code = item.caiwu_code
      this.update_group_item.caiwu_code_status = item.caiwu_code_status
      this.update_group_item.jindie_code = item.jindie_code
    },

    search() {
      this.page = 1;
      this.get_group_project();
    },

    page_change(e) {
      console.log(e);
      this.page = e;
      this.get_group_project();
    },

    //获取项目组
    get_group_project() {
      var that = this;
      var obj = {
        page: this.page,
        name: this.search_key,
        dep_list: this.select_dep,
        operation_status: this.operation_status_index,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/group_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.group_columns = res.data.columns;
            that.group_list = res.data.data_list;
            that.total_count = res.data.total_count;
            that.limit = res.data.limit;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    add_project() {
      if (this.company_name == "") {
        this.$Message.error("请输入项目全称");
        return;
      }
      // if (this.company_short_name == '') {
      //     this.$Message.error('请输入项目简称')
      //     return
      // }
      if (this.select_city.length == 0) {
        this.$Message.error("请选择项目区域");
        return;
      }
      // if (this.business == "") {
      //   this.$Message.error("请填写公司主营");
      //   return;
      // }
      // if (this.contract_url == '') {
      //     this.$Message.error('请上传业务合同PDF')
      //     return
      // }
      // if (this.contract_start_time == '') {
      //     this.$Message.error('请选择合同开始时间')
      //     return
      // }
      // if (this.contract_end_time == '') {
      //     this.$Message.error('请选择合同结束时间')
      //     return
      // }
      if (this.select_dep.length == 0) {
        this.$Message.error("请选择所属部门");
        return;
      }

      var that = this;
      var obj = {
        company_name: this.company_name,
        company_short_name: this.company_short_name,
        select_city: this.select_city,
        business: this.business,
        contract_url: this.contract_url,
        contract_start_time: this.contract_start_time,
        contract_end_time: this.contract_end_time,
        select_dep: this.select_dep,
        jindie_code:this.jindie_code,
        jindie_salesdept:this.jindie_salesdept
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/project_group",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    contract_start_chnage(e) {
      this.contract_start_time = new Date(e).getTime() / 1000;
    },

    contract_end_chnage(e) {
      this.contract_end_time = new Date(e).getTime() / 1000;
    },

    contract_upload_success(e) {
      console.log(e);
      this.contract_url = e.data.url;
    },

    //获取部门选择器
    get_dep_options() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/create/dep_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.dep_options = res.data.dep_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取地区数据
    get_city_options() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/common/city_options", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.city_options = res.data.city_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    down_pdf(url) {
      console.log(url);
      if (url) {
        open_new_page(url);
      } else {
        this.$Message.warning("没有找到合同,无法下载");
      }
    },

    click_project_count(row) {
      console.log(row)
      var str2 = ''
      for (var i = 0; i < row.project_basic_list.length; i++) {
        var project_name = row.project_basic_list[i]['project_name']
        var str1 = '<p>[' + String(i + 1) + '] ' + project_name + '</p>'
        str2 += str1
      }
      this.$Modal.confirm({
        title: "项目组下项目列表",
        content: "<p>" + str2 + "</p>",
        onOk: () => {
        },
        onCancel: () => {
        },
      });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.caiwucode {
  background: #5cae54;
  color: #fff;
  padding: 1px 2px;
  border-radius: 2px;
}

.caiwucode2 {
  background: #f92b43;
  color: #fff;
  padding: 1px 2px;
  border-radius: 2px;
}

.project_count_tag {
  padding: 1px 3px;
  font-size: 12px;
  background: #0466dd;
  color: #fff;
  cursor: pointer;
  border-radius: 3px;
  margin-right: 5px;
}

.project_count_tag2 {
  padding: 1px 3px;
  font-size: 12px;
  background: #ff2222;
  color: #fff;
  cursor: pointer;
  border-radius: 3px;
  margin-right: 5px;
}

.project_tag {
  padding: 1px 3px;
  font-size: 12px;
  background: #5cae54;
  color: #fff;
  border-radius: 3px;
  margin-right: 5px;
}

.project_tag2 {
  padding: 1px 3px;
  font-size: 12px;
  background: #f12400;
  color: #fff;
  border-radius: 3px;
  margin-right: 5px;
}

.editor_icon {
  margin-left: 3px;
  cursor: pointer;
}

.editor_icon:hover {
  color: #0466dd;
}

.down_pdf_a {
  color: #0466dd;
}

.table_box {
  margin-top: 10px;
}

.search_box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.page_div {
  padding-top: 5px;
  display: flex;
  padding-bottom: 5px;
  justify-content: center;
}

.box_line {
  height: 0.5px;
  margin: 20px 10px;
  background-color: #f0f0f0;
}

.add_button_div {
  margin: 20px 10px 10px 0;
  display: flex;
  justify-content: flex-end;
}

.field_title {
  width: 120px;
  flex-shrink: 0;
}

.field_item {
  display: flex;
  align-items: center;
  margin: 10px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content_inner {}

.content {
  background-color: #fff;
  right: 0px;
  top: 0px;
  height: calc(100vh - 50px);
  overflow: auto;
  padding: 0px 10px 0 10px;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
